import { render } from "./OwnerAccount-AddCompany.vue?vue&type=template&id=004e42b7&scoped=true"
import script from "./OwnerAccount-AddCompany.vue?vue&type=script&lang=js"
export * from "./OwnerAccount-AddCompany.vue?vue&type=script&lang=js"

import "./OwnerAccount-AddCompany.vue?vue&type=style&index=0&id=004e42b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004e42b7"]])

export default __exports__